export const HISTORY_LOG_TYPES = {
    category: 1,
    jobTitle: 2,
    section: 3,
    fileTemplate: 4
};
